import 'unfetch/polyfill/index'

import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { onError } from 'apollo-link-error'
import { createUploadLink } from 'apollo-upload-client'
import { createBrowserHistory } from 'history'
import React from 'react'
import { ApolloProvider } from 'react-apollo'
import { Route, Router, Switch } from 'react-router-dom'
import ThemeManager from '../src/components/modules/ThemeManager'
import { webSocketDefaultProps } from '../src/graphql/client/schema'
import {
  currentDependentDefaultProps,
  guiDefaultProps,
  resolvers,
} from '../src/graphql/client/webschema'
import RegisterInvitationPage from './components/pages/RegisterInvitationPage'
import ForgotPasswordPage from './components/pages/ForgotPasswordPage'
import ResetPasswordPage from './components/pages/ResetPasswordPage'
import Layout from './components/pages/Layout'
import RegistrationPage from './components/pages/RegistrationPage'
import ResendInvitationPage from './components/pages/ResendInvitationPage'
import SignInPage from './components/pages/SignInPage'
import VerifyTwofaTokenPage from './components/pages/VerifyTwofaTokenPage'

const browserHistory = createBrowserHistory()

// use router for relative account links
document.addEventListener('click', (e: any) => {
  const href = e.target && e.target.getAttribute('href')
  if (href && href.indexOf('/') === 0) {
    e.preventDefault()
    browserHistory.push(href)
  }
})

const cache = new InMemoryCache()
const errorLink = onError(({ graphQLErrors, networkError }: any) => {
  if (networkError) {
    // const { statusCode } = networkError
    // console.log('networkError', statusCode)
    return
  }
  if (graphQLErrors) {
    // const err = graphQLErrors[0]
    // console.log('graphQLErrors', err)
    return
  }
}) as any
// TODO: figure out why we need to explicitly grab and send this
const csrfTokenEl = document.querySelector('meta[name="csrf-token"]')
const uploadLink = createUploadLink({
  credentials: 'include',
  fetch,
  headers: {
    'X-CSRF-TOKEN': csrfTokenEl && csrfTokenEl.getAttribute('content'),
  },
  uri: '/api/account',
}) as any
const link = ApolloLink.from([errorLink, uploadLink]) as any
const client = new ApolloClient({
  cache,
  defaultOptions: {
    mutate: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    },
  },
  link,
  resolvers,
})
cache.writeData({
  data: {
    currentDependent: currentDependentDefaultProps,
    gui: guiDefaultProps,
    webSocket: webSocketDefaultProps,
  },
})

const Index: React.FC = () => {
  // override main web-app's non-scroll
  const overrideStyles = {
    body: {
      height: '100vh',
      overflow: 'scroll',
      padding: '0 0 80px',
    },
    html: {
      height: 'auto',
      overflow: 'scroll',
    },
  }
  return (
    <ThemeManager overrideStyles={overrideStyles}>
      <ApolloProvider client={client}>
        <Router history={browserHistory}>
          <Layout>
            <Switch>
              <Route
                path="/doctors/invitation/accept"
                component={RegisterInvitationPage}
              />
              <Route
                path="/patients/invitation/accept"
                component={RegisterInvitationPage}
              />
              <Route
                path="/invitation/resend"
                component={ResendInvitationPage}
              />
              <Route path="/sign_in" component={SignInPage} />
              <Route path="/password/new" component={ForgotPasswordPage} />
              <Route path="/password/edit" component={ResetPasswordPage} />
              <Route path="/verify_token" component={VerifyTwofaTokenPage} />
              <Route path="/register" component={RegistrationPage} />
              <Route exact path="/" component={RegistrationPage} />
            </Switch>
          </Layout>
        </Router>
      </ApolloProvider>
    </ThemeManager>
  )
}

export default Index
